import { z } from 'zod';
import _isEmpty from 'lodash/isEmpty';

const LabelTypes = z.enum(['paperless', 'no_box_no_label']);

export const FORM_SCHEMA = z.object({
  slas: z.record(z.boolean()).refine(slas => !_isEmpty(slas), {
    message: 'At least one service must be selected.'
  }),
  labelTypes: z.record(
    LabelTypes,
    z.object({
      isEnabled: z.boolean()
    })
  )
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  slas: {},
  labelTypes: {}
};

export const LABEL_TYPES = LabelTypes.options;
